import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import SectionTitle from '@components/sectionTitle/SectionTitle'
import Icon from '@components/icon/Icons'
import DocumentsSection from '@components/sections/DocumentsSection'

import useI18n from '@i18n/useI18n'

import theme from '@theme/Theme'

interface Props {
  manifestation: ManifestationDetailResponse
  edlList: EtatDesLieuxResponse[]
  controles: ControleQualiteResponse[]
}

const ManifestationTopSection = ({ manifestation, edlList, controles }: Props) => {
  const i18n = useI18n()

  const renderContact = (chef: ChefProjetManifestationResponse) => (
    <ContactContent key={chef.email}>
      {!!chef.prenom && !!chef.nom && <FullName>{`${chef.prenom} ${chef.nom}`}</FullName>}

      {!!chef.telephone && (
        <Info>
          <Icon name="phone" size={24} color={theme.colors.primary} />
          <Value>{chef.telephone}</Value>
        </Info>
      )}

      {!!chef.email && (
        <Info>
          <Icon name="email" size={24} color={theme.colors.primary} />
          <Value>{chef.email}</Value>
        </Info>
      )}
    </ContactContent>
  )

  return (
    <TopSections>
      {manifestation.chefProjetManifestation.length > 0 && (
        <ContactContainer>
          <TitleContainer>
            <SectionTitle title={i18n.t('screens.tenant.contact')} />
          </TitleContainer>
          {manifestation.chefProjetManifestation.map(renderContact)}
        </ContactContainer>
      )}

      <DocumentsSection
        documents={{ edl: {}, quality: controles }}
        id={manifestation.id}
        isManifestation
        edlList={edlList}
      />
    </TopSections>
  )
}

export default ManifestationTopSection

const TopSections = styled(View)`
  flex-direction: ${(props) => (props.theme.breakpoint === 'big' ? 'row' : 'column')};
  margin-bottom: 16px;
`
const ContactContainer = styled(View)`
  ${(props) => props.theme.breakpoint === 'big' && `flex: 1;`}
  min-width: 250px;
`
const ContactContent = styled(View)`
  margin: 16px 0;
`
const FullName = styled(Text)`
  ${(props) => props.theme.fonts.Callout};
`
const Info = styled(View)`
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
`
const Value = styled(Text)`
  ${(props) => props.theme.fonts.Body};
  font-size: 16px;
  margin-left: 16px;
`
const TitleContainer = styled(View)`
  height: 48px;
  justify-content: center;
`
